export const ROUTE_PERMISSIONS = {
  '/admin/dashboard': [],
  '/admin/items': [{ identifier: 'item-list', method: 'GET' }],
  '/admin/users': [{ identifier: 'admin_users', method: 'GET' }],
  '/admin/device-info': [{ identifier: 'admin_users', method: 'GET' }],
  '/admin/product-requests': [],
  '/admin/invoice-management': [{ identifier: 'invoice-list', method: 'GET' }],
  '/admin/payment-methods': [{ identifier: 'admin_payment_methods', method: 'GET' }],
  '/admin/payment-details': [{ identifier: 'admin_payment_details', method: 'GET' }],
  '/admin/system-messages': [{ identifier: 'system-messages-list', method: 'GET' }],
  '/admin/banners': [{ identifier: 'admin_banner_list', method: 'GET' }],
  '/admin/manual-item-add': [{ identifier: 'admin_manual_item_add', method: 'POST' }],
  '/admin/pre-order/create': [{ identifier: 'admin_preorder_items', method: 'POST' }],
  '/admin/pre-order/manage': [{ identifier: 'admin_preorder_items', method: 'GET' }],
  '/admin/pre-order/edit/:itemId': [{ identifier: 'admin_preorder_item_detail', method: 'GET' }],
  '/admin/local-supplier-items': [{ identifier: 'item-add-local-supplier-item', method: 'POST' }],
  '/admin/affiliate': [{ identifier: 'admin_affiliate_view', method: 'GET' }],
  '/admin/affiliate/rankings': [{ identifier: 'admin-affiliate-rankings', method: 'GET' }],
  '/admin/affiliate/referrals': [{ identifier: 'admin_affiliate_view', method: 'GET' }],
  '/admin/affiliate/manual-link': [
    { identifier: 'admin-affiliate-manual-link-search-affiliate', method: 'GET' },
    { identifier: 'admin-affiliate-manual-link-search-user', method: 'GET' },
    { identifier: 'admin-affiliate-manual-link', method: 'POST' },
  ],
  '/admin/version-management': [{ identifier: 'appversion-list', method: 'GET' }],
  '/admin/currency-rates': [{ identifier: 'currency-rate-list', method: 'GET' }],
  '/admin/settings': [{ identifier: 'admin_settings-list', method: 'GET' }],
  '/admin/orders': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/all': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/unpaid': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/processing': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/purchased': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/in-warehouse': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/shipped-out': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/in-nigeria': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/receieved': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/refunded': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/success': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/closed': [{ identifier: 'order-list', method: 'GET' }],
  '/admin/orders/pending-approval': [{ identifier: 'admin-pending-orders', method: 'GET' }],
  '/admin/orders/purchasing-references': [{ identifier: 'admin-purchasing-platform-list', method: 'GET' }],
  '/admin/packages': [{ identifier: 'package-list', method: 'GET' }],
  '/admin/shipments': [{ identifier: 'admin-shipment-list', method: 'GET' }],
  '/admin/shipments/carriers': [{ identifier: 'admin-shipment-carrier-list-create', method: 'GET' }],
  '/admin/shipments/create': [
    { identifier: 'admin-shipment-carrier-list-create', method: 'GET' },
    { identifier: 'admin-shipment-create', method: 'POST' },
  ],
  '/admin/packages/assisted': [{ identifier: 'package-assisted-search', method: 'GET' }],
  '/admin/cart': [{ identifier: 'admin-cart-list', method: 'GET' }],
  '/admin/cart/checkout': [{ identifier: 'admin-create-order', method: 'POST' }],
  '/admin/wallets': [{ identifier: 'admin_wallets_list', method: 'GET' }],
  '/admin/bonus-management': [],
  '/admin/banks': [{ identifier: 'bank-list', method: 'GET' }],
  '/admin/rmb/exchange-rate': [{ identifier: 'currency-rate-list', method: 'GET' }],
  '/admin/rmb/history': [{ identifier: 'currency-rate-list', method: 'GET' }],
  '/admin/rmb/transactions': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/fulfillment/service-types': [{ identifier: 'admin-service-type-list', method: 'GET' }],
  '/admin/fulfillment/pricing': [{ identifier: 'admin-service-type-pricing-list', method: 'GET' }],
  '/admin/fulfillment/addons': [{ identifier: 'admin-addon-service-list', method: 'GET' }],
  '/admin/fulfillment/storage': [{ identifier: 'admin-storage-pricing-list', method: 'GET' }],
  '/admin/fulfillment/warehouse-address': [{ identifier: 'admin-warehouse-address-list', method: 'GET' }],
  '/admin/fulfillment/requests': [{ identifier: 'admin-fulfillment-request-list', method: 'GET' }],
  '/admin/ai/faq': [{ identifier: 'faq-list', method: 'GET' }],
  '/admin/affiliate/list': [{ identifier: 'admin_affiliate_view', method: 'GET' }],
  '/admin/employees/salary/structures': [{ identifier: 'salary-structure-list', method: 'GET' }],
  '/admin/employees/salary/tax/configurations': [{ identifier: 'tax-configuration-list', method: 'GET' }],
  '/admin/employees/salary/tax/brackets': [{ identifier: 'tax-bracket-list', method: 'GET' }],
  '/admin/employees/salary/benefits/types': [{ identifier: 'benefit-type-list', method: 'GET' }],
  '/admin/employees/salary/benefits/employee-benefits': [{ identifier: 'employee-benefit-list', method: 'GET' }],
  '/admin/employees/salary/bonuses': [{ identifier: 'bonus-list', method: 'GET' }],
  '/admin/employees/salary/commissions': [{ identifier: 'employees_admin:commission-list', method: 'GET' }],
  '/admin/logistics': [{ identifier: 'logistics-list', method: 'GET' }],
  '/admin/logistics/info': [],
  '/admin/group-shipping': [{ identifier: 'admin-shipping-pools-list', method: 'GET' }],
  '/admin/transactions': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/inward': [{ identifier: 'admin_inward_transactions_list', method: 'GET' }],
  '/admin/transactions/topup': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/withdraw': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/refund': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/business': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/income': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/transfer': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/bonus': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/debit': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/transactions/invoice': [{ identifier: 'admin_transactions', method: 'GET' }],
  '/admin/search-history': [{ identifier: 'admin_search_history_list', method: 'GET' }],
  '/admin/translate-settings': [{ identifier: 'admin_translation_settings_list', method: 'GET' }],
  '/admin/platform-translations': [{ identifier: 'admin_platform_translations_list', method: 'GET' }],
  '/admin/wallet-management': [{ identifier: 'admin_wallet_manual_logs', method: 'GET' }],
  '/admin/wallet-management/logs': [{ identifier: 'admin_wallet_manual_logs', method: 'GET' }],
  '/admin/wallet-management/manual-adjust': [{ identifier: 'admin_wallet_manual_adjust', method: 'POST' }],
  '/admin/withdrawals': [{ identifier: 'admin_withdrawals', method: 'GET' }],
  '/admin/location/country': [
    { identifier: 'country-list', method: 'GET' },
    { identifier: 'state-list', method: 'GET' },
    { identifier: 'city-list', method: 'GET' },
  ],
  '/admin/location/state': [
    { identifier: 'country-list', method: 'GET' },
    { identifier: 'state-list', method: 'GET' },
    { identifier: 'city-list', method: 'GET' },
  ],
  '/admin/location/city': [
    { identifier: 'country-list', method: 'GET' },
    { identifier: 'state-list', method: 'GET' },
    { identifier: 'city-list', method: 'GET' },
  ],
  '/admin/api-management': [{ identifier: 'admin_api_providers_list', method: 'GET' }],
  '/admin/api-key-management': [{ identifier: 'admin_api_keys_list', method: 'GET' }],
  '/admin/api-usage-logs': [{ identifier: 'admin_api_usage_logs_list', method: 'GET' }],
  '/admin/api-statistics': [{ identifier: 'admin_api_statistics', method: 'GET' }],
  '/admin/access-control': [{ identifier: 'admin-rbac-list', method: 'GET' }],
  '/admin/rbac/access-control': [{ identifier: 'admin-rbac-list', method: 'GET' }],
  '/admin/rbac/roles': [{ identifier: 'admin-rbac-roles-list', method: 'GET' }],
  '/admin/profit-analytics': [{ identifier: 'profit-analytics-view', method: 'GET' }],
  '/admin/rmb-profit-analytics': [{ identifier: 'rmb-profit-analytics-view', method: 'GET' }],
  '/admin/marketing/managers': [{ identifier: 'marketing_admin:marketing-manager-list', method: 'GET' }],
  '/admin/marketing/assignments': [{ identifier: 'marketing_admin:assignment-list', method: 'GET' }],
  '/admin/marketing/my-assignments': [{ identifier: 'marketing_admin:my-assignments', method: 'GET' }],
  '/admin/marketing/manual-claim': [{ identifier: 'marketing_admin:assignment-list', method: 'GET' }],
  '/admin/marketing/commission-tiers': [{ identifier: 'marketing_admin:commission-tier-list', method: 'GET' }],
  '/admin/marketing/commissions': [{ identifier: 'marketing_admin:commission-list', method: 'GET' }],
  '/admin/marketing/performance': [{ identifier: 'marketing_admin:performance-list', method: 'GET' }],
  '/admin/marketing/website-analytics': [{ identifier: 'marketing_admin:website-analytics', method: 'GET' }],
  '/admin/marketing/attribution': [
    { identifier: 'marketing_admin:attribution-summary', method: 'GET' },
    { identifier: 'marketing_admin:marketing-event-list', method: 'GET' },
  ],
  '/admin/marketing/claim': [
    { identifier: 'marketing_admin:claim-customer', method: 'GET' },
    { identifier: 'marketing_admin:claim-customer', method: 'POST' },
  ],
  '/admin/employees': [{ identifier: 'employee-list', method: 'GET' }],
  '/admin/employees/departments': [{ identifier: 'department-list', method: 'GET' }],
  '/admin/employees/positions': [{ identifier: 'position-list', method: 'GET' }],
  '/admin/employees/leave-types': [{ identifier: 'leave-type-list', method: 'GET' }],
  '/admin/employees/leave-requests': [{ identifier: 'leave-request-list', method: 'GET' }],
  '/admin/employees/attendance': [{ identifier: 'attendance-list', method: 'GET' }],
  '/admin/employees/documents': [{ identifier: 'document-list', method: 'GET' }],
  '/admin/employees/dashboard': [{ identifier: 'employee-dashboard', method: 'GET' }],
  '/admin/analytics/user-activity': [{ identifier: 'analytics_admin:analytics_active_users_summary', method: 'GET' }],
  '/admin/virtual-accounts': [
    { identifier: 'admin_virtual_account_stats', method: 'GET' },
    { identifier: 'admin_virtual_account_create', method: 'POST' },
  ],
  '/admin/packaging-materials': [{ identifier: 'packaging-material-list', method: 'GET' }],
  '/admin/group-shipping/settings': [{ identifier: 'admin_pool_settings', method: 'GET' }],
  '/admin/expenses': [{ identifier: 'expense-list', method: 'GET' }],
  '/admin/expenses/create': [{ identifier: 'expense-list', method: 'POST' }],
  '/admin/expenses/accounting-periods': [{ identifier: 'accountingperiod-list', method: 'GET' }],
  '/admin/support-chat': [{ identifier: 'admin-support-chat-session-list', method: 'GET' }],
  '/admin/support-chat/knowledge': [{ identifier: 'admin-support-chat-knowledge-list', method: 'GET' }],
  '/admin/support-chat/agent-ratings': [{ identifier: 'admin-support-chat-agent-rating-list', method: 'GET' }],
  '/admin/support-chat/:id': [{ identifier: 'admin-support-chat-session-detail', method: 'GET' }],
  '/admin/reviews': [{ identifier: 'admin-review-list', method: 'GET' }],
  '/admin/products': [],
  '/admin/categories': [],
  '/admin/brands': [],
  '/admin/brand-requests': [],
  '/admin/schema': [],
  '/admin/schema-manager': [],
  '/admin/moderation': [],
  '/admin/moderation/model-management': [],
  '/admin/moderation/config': [],
  '/admin/moderation/auto-approval-settings': [],
  '/admin/merchants': [],
  '/admin/merchant-admin/warehouses': [],
  '/admin/merchant-admin/rate-cards': [],
  '/admin/merchant-admin/storage-accounts': [],
  '/admin/merchant-admin/inbound-shipments': [],
  '/admin/merchant-admin/inventory': [],
  '/admin/merchant-admin/charges': [],
  '/admin/merchant-admin/invoices': [],
  '/admin/merchant-admin/fulfillments': [],
  '/admin/merchant-admin/warehouse-lifecycle': [],
  '/admin/group-buy/active': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/closed': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/purchased': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/in-warehouse': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/in-transit': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/in-nigeria': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/fulfilled': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/cancelled': [{ identifier: 'admin_group_buy_pools', method: 'GET' }],
  '/admin/group-buy/create': [{ identifier: 'admin_create_pool', method: 'POST' }],
  '/admin/group-buy/analytics': [{ identifier: 'admin_group_buy_analytics', method: 'GET' }],
  '/admin/group-buy/settings': [{ identifier: 'admin_group_buy_settings', method: 'GET' }],
};

export const getRoutePermissions = (path) => ROUTE_PERMISSIONS[path] || [];
